/* @flow */

import * as React from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMask } from '@fortawesome/free-solid-svg-icons';

import t from 'app/utils/translate';
import { PlayChip } from 'app/components/styled/currencyIcons';
import Icon from '../commons/Icon';
import FeaturedIcon from '../icons/FeaturedIcon';
import Legend from '../commons/Legend';
import LegendItem from '../commons/LegendItem';
import PlayerSelectionIcon from '../icons/PlayerSelectionIcon';
import CasualContestIcon from '../icons/CasualContestIcon';
import styled from '@emotion/styled';
import RookieIcon from 'app/images/app/Rookie.svg';
import RestrictedContestIcon from '../icons/RestrictedContestIcon';

type Props = {
  showDrop1: boolean,
  showFeatured: boolean,
  showMultiEntry: boolean,
  showMultipliers: boolean,
  showPayout: boolean,
  showPlayerSelection: boolean,
  showPlayChip: boolean,
  showH2H: boolean
};

function ChallengesListLegend({
  showDrop1,
  showFeatured,
  showPayout,
  showPlayerSelection,
  showPlayChip,
  showMultiEntry,
  showMultipliers,
  showH2H
}: Props) {
  return (
    <Legend arrow="topright">
      {showFeatured && <LegendItem description="Featured challenges" icon={<FeaturedIcon />} />}
      {showPlayerSelection && (
        <LegendItem description="Player selection % displayed" icon={<PlayerSelectionIcon />} />
      )}
      {showPayout && (
        <LegendItem
          description={t('Guaranteed Prizepool')}
          icon={<Icon type="icon-payout-guaranteed" />}
        />
      )}
      {showPayout && (
        <LegendItem
          description={t('Guaranteed Prizepool Plus')}
          icon={<Icon type="icon-payout-guaranteed-plus" />}
        />
      )}
      {showMultiEntry && (
        <LegendItem description={t('Multi Entry')} icon={<Icon type="icon-multientry" />} />
      )}
      <LegendItem description={`Captain ${t('Challenge')}`} icon={<Icon type="icon-captain" />} />
      {showMultipliers && (
        <React.Fragment>
          <LegendItem description="Multiplier x2" icon={<Icon type="icon-payout-x2" />} />
          <LegendItem description="Multiplier x3" icon={<Icon type="icon-payout-x3" />} />
          <LegendItem description="Multiplier x5" icon={<Icon type="icon-payout-x5" />} />
          <LegendItem description="Multiplier x10" icon={<Icon type="icon-payout-x10" />} />
        </React.Fragment>
      )}
      {showH2H && <LegendItem description="Head to Head" icon={<Icon type="icon-h2h" />} />}
      {showH2H && (
        <LegendItem description="User Created H2H" icon={<Icon type="icon-user-h2h" />} />
      )}
      {showH2H && (
        <LegendItem
          description={`User Created ${t('Challenge')}`}
          icon={<Icon type="icon-user" />}
        />
      )}
      {showH2H && (
        <LegendItem
          description={`Private ${t('Challenge')}`}
          icon={<FontAwesomeIcon icon={faMask} color="#fd7024" size="sm" />}
        />
      )}
      {showPayout && <LegendItem description={t('Target')} icon={<Icon type="icon-target" />} />}
      {showPlayChip && <LegendItem description={t('PlayChip')} icon={<PlayChip />} />}
      {showDrop1 && (
        <LegendItem description={t('Drop1 contest format')} icon={<Icon type="icon-drop1" />} />
      )}
      <LegendItem description={`Casual ${t('Challenge')}`} icon={<CasualContestIcon />} />
      <LegendItem
        description={`You are ineligible to enter this ${t('challenge')}`}
        icon={<RestrictedContestIcon />}
      />
      <LegendItem
        description="ROOKIE CONTEST"
        icon={<RookieImg src={RookieIcon} alt="rookies" width={18} />}
      />
    </Legend>
  );
}
const RookieImg = styled.img({
  display: 'inline-block'
});
function mapStateToProps(state) {
  return {
    showFeatured: true,
    showH2H: state.settings.hasH2H,
    showMultiEntry: state.settings.multiEntry,
    showMultipliers: state.settings.hasMultiplierPayout,
    showPayout: true,
    showPlayChip: state.settings.currency.symbol === 'PLA',
    showPlayerSelection: false,
    showDrop1: true
  };
}

export default connect(mapStateToProps)(ChallengesListLegend);
